import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'

import { CompLoginFormWrapperCore } from '../core/login-form/wrapper'

/**
 * Login Form Component Wrapper
 *
 * @todo inject auth plugins from parent
 */
const CompLoginFormWrapper = () => {
  // global
  const { language } = useDbClientContext()

  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionCtx = useBuilderActionContextV2()

  return <CompLoginFormWrapperCore infos={infosProps} action={actionCtx} language={language} />
}

export default CompLoginFormWrapper
